import MarkdownIt from "markdown-it"
import DOMPurify from "dompurify"
import { youtube } from "../markdown-it/youtube"
import { icon } from "../markdown-it/icon"
import { br } from "../markdown-it/br"
import MarkdownItMultimdTable from "markdown-it-multimd-table"

export default {
  data: () => ({
    raw: "",
    parsed: "",
  }),
  computed: {
    isSecuratingAccount() {
      return this.$store.state.auth.user["doc"] === true
    },
  },
  methods: {
    parse(content) {
      this.raw = content

      const parser = MarkdownIt({
        html: true, // Enable HTML tags in source
        linkify: true, // Autoconvert URL-like text to links
        typographer: true, // Enable some language-neutral replacement + quotes beautification
        breaks: true,
      }).use(MarkdownItMultimdTable)

      DOMPurify.addHook("afterSanitizeAttributes", function(node) {
        if (node.nodeName && node.nodeName === "IFRAME") {
          if (!node.attributes.src.value.toString().startsWith("https://www.youtube-nocookie.com/embed")) {
            if (node.parentNode) {
              node.parentNode.removeChild(node)
            }
          }
        }
      })

      let tmp = icon(youtube(br(this.raw)))

      this.parsed = parser.render(
        DOMPurify.sanitize(tmp, {
          ALLOWED_TAGS: ["iframe", "i", "table", "tr", "td", "img", "br", "button", "span", "div"],
          ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "class", "type", "style"],
        })
      )

      let nodes = Array.from(new DOMParser().parseFromString(this.parsed, "text/html").body.childNodes)

      let rNodes = []

      for (let i in nodes) {
        let node = nodes[i]
        switch (node.localName) {
          case "h1":
            node.className = "display-1"
            break
          case "h2":
            node.className = "headline"
            break
          case "h3":
            node.className = "title"
            break
          case "h4":
            node.className = "subtitle-1"
            break
          case "ul":
            node.className = "sr-ul"
            break
          case "ol":
            node.className = "sr-ol"
            break
          case "pre":
            if (node.firstChild.className === "language-comments" && !this.isSecuratingAccount) {
              continue
            }
            break
        }
        // This line is useful to add more spaces
        // rNodes[i] = node.outerHTML !== undefined ? node.outerHTML : "<br>";
        if (node.outerHTML !== undefined) {
          rNodes[i] = node.outerHTML
        }
      }

      this.parsed = rNodes.join("")
      this.parsed = `<div class="sr-documentation">${this.parsed}</div>`
    },
  },
}
